// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".theme--light.v-data-table tbody tr:hover:not(.v-data-table__expand-row){background:#eee;cursor:pointer!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
